import request from '@/utils/request'


// 查询联系客服列表
export function listPlatform(query) {
  return request({
    url: '/platform/platform/list',
    method: 'get',
    params: query
  })
}

// 查询联系客服分页
export function pagePlatform(query) {
  return request({
    url: '/platform/platform/page',
    method: 'get',
    params: query
  })
}

// 查询联系客服详细
export function getPlatform(data) {
  return request({
    url: '/platform/platform/detail',
    method: 'get',
    params: data
  })
}

// 新增联系客服
export function addPlatform(data) {
  return request({
    url: '/platform/platform/add',
    method: 'post',
    data: data
  })
}

// 修改联系客服
export function updatePlatform(data) {
  return request({
    url: '/platform/platform/edit',
    method: 'post',
    data: data
  })
}

// 删除联系客服
export function delPlatform(data) {
  return request({
    url: '/platform/platform/delete',
    method: 'post',
    data: data
  })
}
